import apiService from "./apiService";
import AppConstants from "../appConstants";

class ContentRelevanceService {
    getAllContentRelevance(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTENT_RELEVANCE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getContentRelevanceDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_CONTENT_RELEVANCE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerContentRelevance(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CONTENT_RELEVANCE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteContentRelevance(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_CONTENT_RELEVANCE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CONTENT_RELEVANCE_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }


    // =====================================================================

}

export default new ContentRelevanceService();
